import sqFetch from 'application/fetch';
import { getLanguageCode, getCountryCode } from 'utilities/locales';

const UPDATE_CART_URL = '/shop/api/cart';

const updateCart = (
  requestParams,
  onSuccess = () => {},
  onError = () => {},
) => {
  sqFetch
    .put(UPDATE_CART_URL, requestParams)
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .then(onSuccess)
    .catch(onError);
};

const updateItem = (
  variantToken,
  quantity,
  addOnIds,
  onSuccess = () => {},
  onError = () => {},
  action = 'add',
  bopisLocationId = null,
  bopisSearchPostalCode = null,
) => {
  const requestParams = {
    store_code: getCountryCode(),
    getLanguageCode: getLanguageCode(),
    update_cart_action: action,
    line_items_attributes: [
      {
        variant_token: variantToken,
        quantity,
        add_ons: addOnIds,
      },
    ],
  };

  if (bopisLocationId !== null && bopisSearchPostalCode !== null) {
    requestParams.location_id = bopisLocationId;
    requestParams.search_postal_code = bopisSearchPostalCode;
  }

  updateCart(requestParams, onSuccess, onError);
};

const showPaymentForm = (orderData) => {
  if (orderData.is_warranty) return true; // we always save a card on warranties

  switch (orderData.payment_due.payment_schedule) {
    case 'upfront': {
      return (
        Number.parseFloat(orderData.payment_due.amount) > 0 ||
        orderData?.upfront_card_payment_only ||
        orderData?.is_hardware_rental_order ||
        orderData?.requires_card_on_file
      );
    }
    case 'installment': {
      return true;
    }
    case 'purchase_order': {
      return false;
    }
    default: {
      // this should never hit but if there's funky business, just show the payment form
      return true;
    }
  }
};

export { showPaymentForm, updateItem };
